module.exports = __webpack_public_path__ + "img/engineer@2x.b804505c.png";